exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@media only screen and (max-width:768px){iframe[data-v-51ec59da]{width:85vw}}iframe[data-v-51ec59da]{width:100%}a[data-v-51ec59da]{color:hotpink}", "", {"version":3,"sources":["/opt/build/repo/cowork-panel/src/components/Podcast.vue"],"names":[],"mappings":"AACA,yCACA,wBACM,UAAY,CACjB,CACA,AACD,wBACI,UAAY,CACf,AACD,mBACE,aAAe,CAChB","file":"Podcast.vue","sourcesContent":["\n@media only screen and (max-width: 768px) {\niframe[data-v-51ec59da] {\n      width: 85vw;\n}\n}\niframe[data-v-51ec59da] {\n    width: 100%;\n}\na[data-v-51ec59da] {\n  color: hotpink;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-51ec59da","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Podcast.vue
// module id = 196
// module chunks = 17